import heic2any from 'heic2any';
import { readAndCompressImage } from 'browser-image-resizer';


export const processImage = async (file: File): Promise<Blob> => {
  // const fileName = file.name || `image.${file.type.split('/')[1]}}`;
  // console.log(file, file.size / 1e+6);

  if (file.type === 'image/gif'
    || file.type.startsWith('video')
    || file.type.startsWith('audio')) {
    return file;
  }

  if (file.type === 'image/heic') {
    file = await heic2any({
      blob: file,
      toType: 'image/jpeg'
    }) as File;
  }

  // console.log(file, file.size / 1e+6);

  file = await readAndCompressImage(file, {
    maxWidth: 1000,
    maxHeight: 1000,
    quality: 90
  }) as File;

  return file;
}
